var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recent-news-carousel columns is-mobile is-multiline" },
    [
      _c("div", { staticClass: "column is-3-desktop is-2-mobile" }, [
        _c("h3", { staticClass: "recent-news__month" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column is-9-desktop is-10-mobile" },
        [
          _c(
            "slick",
            {
              ref: "slick",
              attrs: { options: _vm.slickOptions },
              on: { init: _vm.handleInit }
            },
            [_vm._t("default")],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "column is-12" }, [
        _c("div", { staticClass: "recent-news-carousel__controls" }, [
          _vm.numberOfSlides > 1
            ? _c("img", {
                attrs: { src: _vm.arrowLeft },
                on: { click: _vm.prev }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.numberOfSlides > 1
            ? _c("img", {
                attrs: { src: _vm.arrowRight },
                on: { click: _vm.next }
              })
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e5609f2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e5609f2","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/recent-news-carousel/RecentNewsCarousel.vue
// module id = 209
// module chunks = 0